module.exports = __webpack_public_path__ + "img/EDSB_120X35.407f04de.png";